import { UnitOfMeasure } from 'utils/enums';
import { unitOfMeasureMapping } from 'utils/unitOptions';
import { TSalesInvoiceItems } from 'utils/types';

export const hasCatalogProduct = (item: {
  productId?: number | null;
}) => item.productId != null && item.productId > 0;

export const parseUnitOfMeasure = (
  value: TSalesInvoiceItems['unitOfMeasure']
) => {
  if (typeof value === 'string') {
    return unitOfMeasureMapping[value] ?? UnitOfMeasure.Piece;
  }
  if (typeof value === 'number' && value > 0) {
    return value;
  }
  return UnitOfMeasure.Piece;
};

export const lineAmount = (item: TSalesInvoiceItems) =>
  Number(item.quantity || 0) * Number(item.unitPrice || 0);

export const buildUpsertSalesInvoiceItemPayload = (item: TSalesInvoiceItems) => {
  const unitPrice = Number(item.unitPrice) || 0;
  if (hasCatalogProduct(item)) {
    return {
      productId: item.productId,
      procurementInvoiceId: item.procurementInvoiceId || null,
      quantity: item.quantity,
      unitOfMeasure: item.unitOfMeasure,
      unitPrice
    };
  }

  return {
    productId: null,
    procurementInvoiceId: null,
    noIdProductName: item.noIdProductName || item.productName || '',
    quantity: item.quantity,
    unitOfMeasure: item.unitOfMeasure,
    unitPrice
  };
};

export const mapApiSalesInvoiceItems = (
  apiItems: TSalesInvoiceItems[]
): TSalesInvoiceItems[] =>
  apiItems.map(item => ({
    ...item,
    productName: item.productName || '',
    unitOfMeasure: parseUnitOfMeasure(item.unitOfMeasure),
    total: item.amount ?? lineAmount(item),
    isSubmitted: Boolean(item.salesInvoiceItemId)
  }));
